import { defaultSiteProfile, useSiteProfileContext } from "../contexts/SiteProfileContext";

export { defaultSiteProfile };

export default function useSiteProfile({ enabled = true } = {}) {
  const context = useSiteProfileContext();
  if (!enabled) {
    return {
      error: "",
      loading: false,
      refreshSiteProfile: context.refreshSiteProfile,
      siteProfile: defaultSiteProfile,
    };
  }
  return context;
}
